/**
 * The join bar (web-plan.md F1, D114/D116): what a non-member sees instead
 * of the composer. A 409 is not an error — it is the channel asking for its
 * word, and the bar answers by swapping the button for a field. The password
 * is typed, sent, forgotten.
 */
import { type JSX, Show, createSignal } from "solid-js";

import type { Dict } from "../lib/i18n";
import type { Room } from "../store/types";
import { Button } from "./ds";

export function JoinBar(props: {
  room: Room;
  t: Dict;
  onJoin(password?: string): void;
}): JSX.Element {
  const [password, setPassword] = createSignal("");
  const needsWord = () => props.room.joinPasswordNeeded || props.room.settings.has_password;

  return (
    <div class="join-bar surface-pane">
      <div class="join-bar__column">
        <span class="join-bar__title">{props.room.name}</span>
        <span class="join-bar__hint">
          {props.room.joinPasswordNeeded
            ? props.t.joinWrongPassword()
            : props.t.composerJoinFirst()}
        </span>
      </div>
      <Show when={needsWord()}>
        <input
          class="hotkey-capture join-bar__password"
          type="password"
          placeholder={props.t.joinPassword()}
          value={password()}
          onInput={(e) => setPassword(e.currentTarget.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") props.onJoin(password() || undefined);
          }}
        />
      </Show>
      <Button
        kind="prominent"
        size="medium"
        icon="add"
        disabled={props.room.joining}
        onClick={() => props.onJoin(needsWord() ? password() || undefined : undefined)}
      >
        {props.t.joinChannel()}
      </Button>
    </div>
  );
}
